import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

// 提交选择绑定的银行卡
export function bindCardStep2(account_id: string, item_id: string, mask?: string) {
    return http.post(
        API.TRADE.funding.bindCardStep2(),
        {
            customer_id: security.currentCustomerId,
            plaid_account_id: account_id,
            item_id,
            mask,
            account_id: security.currentAccountId
        },
        {
            params: {
                customer_id: security.currentCustomerId,
                account_id: security.currentAccountId
            }
        }
    );
}
